"use client";

import AuthForm from "../../../../auth/AuthForm";
import StoreBox from "../store-box";
import styles from "../index.module.scss";

const AuthPage = (props) => {
  const { activateBackButton, organisation } = props;
  const storeName = organisation?.name || "Storefront";

  return (
    <StoreBox {...props} handleLocationChange={() => {}}>
      <main className={styles.convetiAuthPage}>
        <section className={styles.convetiAuthIntro}>
          <span>Account access</span>
          <h1>{storeName}</h1>
          <p>Sign in to continue checkout, review your bag, and keep your store details ready.</p>
        </section>

        <section className={styles.convetiAuthPanel}>
          <AuthForm
            defaultLogin={true}
            onBack={null}
            activateBackButton={activateBackButton}
          />
        </section>
      </main>
    </StoreBox>
  );
};

export default AuthPage;
